import { initContract } from '@ts-rest/core'
import { z } from 'zod'

const c = initContract()

export const AboutStatsSchema = z.object({
  courses:   z.number(),
  contacts:  z.number(),
  graduates: z.number(),
  missioners: z.number(),
})

export type AboutStats = z.infer<typeof AboutStatsSchema>

export const statsContract = c.router({
  getAboutStats: {
    method: 'GET',
    path: '/stats/about',
    responses: { 200: z.any() },
    summary: 'Public about-page stats',
  },
})
